<template>
    <div class="box-container">
        <div class="box-container-header">
            <h3 class="box-title">{{ $t('POLICY.LABEL.APPLIED_RULES')}}<!--적용된 규칙--> <span class="icon-count">{{ruleList.length}}</span></h3>
            <!-- 사용자 정의 Policy 일 때만 규칙 추가 버튼 제공 -->
            <span class="seperate" v-if="isEditable && getMenuAuth === constants.AUTH_TYPE.EDIT">
                <button type="button" class="buttons" data-size="s"
                        data-icon="add"
                        data-trigger="add-rule"
                        @click="callOpenPopup(null, constants.FORM_TYPE.NEW)">
                    {{ $t('POLICY.BUTTON.ADD_RULE')}}<!--규칙 추가-->
                </button>
            </span>
        </div>
        <fieldset class="tbl-filters">
            <legend>table filters</legend>

            <div class="seperate">
                <select-box-multi select-id="select_ctg"
                     select-class="type-checkbox"
                     place-holder="FILTER.SELECT_CATEGORY"
                     :select-box-options="getCtgLabelFilterData"
                     select-box-value=""
                    @onSelectChange="callSetSearchKey('searchCtg',$event.value)"></select-box-multi>

                <select-box-multi select-id="select_prod"
                                  select-class="type-checkbox"
                                  place-holder="FILTER.SELECT_PRODUCT"
                                  :select-box-options="getProdFilterData"
                                  select-box-value=""
                                  @onSelectChange="callSetSearchKey('searchProd',$event.value)"></select-box-multi>
            </div>
            <div class="search-box">
                <label>
                    <input type="search" size="35"
                           :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH')"
                           @keyup="callSetSearchKey('searchTxt', $event.target.value)"
                    >
                </label>
                <button type="button" class="btn-search">Search</button>
            </div>
        </fieldset>

        <div v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="tbl-actions">
            <button type="button" class="buttons" data-type="line" data-size="s" data-icon="delete" :disabled="checkList.length === 0" v-on:click="callDeleteRule(checkList)">{{$t('POLICY.BUTTON.DELETE_RULE')}}</button>
        </div>

        <table class="tbl-default" data-linkable-row>
            <caption></caption>
            <colgroup>
                <col v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" style="width: 34px;">
                <col>
                <col style="width: 347px;">
                <col style="width: 140px;">
                <col v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" style="width: 125px;">
            </colgroup>
            <thead>
            <tr>
                <th v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" scope="col">
                    <input type="checkbox" id="select-all" name="select-all" class="checkbox txt-none" v-model="selectCheckAll">
                    <label for="select-all">{{$t('LABEL.SELECT')}}</label>
                </th>
                <th scope="col">
                    <button type="button" class="buttons-tbl-header" v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            v-on:click="callSetSortColumn('titl')">{{ $t('POLICY.RULE.TITLE')}}<!--규칙 이름--></button>
                </th>
                <th scope="col" data-hide-by-side>
                    <button type="button" class="buttons-tbl-header"
                            v-bind:data-type="sortColumn !== 'prodNm' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            v-on:click="callSetSortColumn('prodNm')">{{ $t('LABEL.PRODUCT')}}<!--프로덕트--></button>
                </th>
                <th scope="col" data-hide-by-side>
                    <button type="button" class="buttons-tbl-header" data-type="filter" data-tooltip-content="#tooltip-svrty-filter">{{ $t('LABEL.SEVERITY')}}<!--심각도--></button>
                    <div class="tooltip_templates">
                        <div id="tooltip-svrty-filter">
                            <ul class="list-filter">
                                <li v-for="(stat, index) of constants.SVRTY_FILTER" :key="index">
                                    <label :for="stat.key">
                                        <input type="checkbox" :id="stat.key" name="filter-type" class="checkbox" :value="stat.key">
                                        {{$t(stat.val)}}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </th>
                <!-- 관리 항목. 사용자 정의 Policy 일 때만 제공 -->
                <th scope="col" v-if="isEditable && getMenuAuth === constants.AUTH_TYPE.EDIT" data-hide-by-side>
                    {{ $t('LABEL.OPTIONS')}}<!--옵션-->
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="rule of ruleList"
                :key="rule.ruleId"
                v-bind:class="{'selected' : curRule != null && rule.ruleId === curRule.ruleId}"
                style="cursor:pointer">
                <td v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="txt-c">
                    <input type="checkbox" :id="rule.ruleId" v-model="checkList" class="checkbox txt-none" :value="rule">
                    <label :for="rule.ruleId">{{$t('LABEL.SELECT')}}</label>
                </td>
                <td v-on:click="openRuleDetail(rule, $event)">
                    <p class="ellipsis-wrpper"><span class="ellipsis" :key="titlRender" :title="isReplica ? rule.transTitl : (rule.siteCd === constants.POLICY_TYPE.BEST_PRACTICE ? rule[$i18n.locale+'RuleTitle'] : rule.titl)">{{(isReplica ? rule.transTitl : rule.siteCd === constants.POLICY_TYPE.BEST_PRACTICE ? rule[$i18n.locale+'RuleTitle'] : rule.titl)}}</span></p>
                    <span data-hide-by-side>
                            <span class="icon-tag" data-type="category-label" v-for="(ctg, index) of rule.ctgLabel" :key="index">{{getCategoryLabel(ctg)}}</span>
                        </span>
                </td>

                <td v-on:click="openRuleDetail(rule, $event)" data-hide-by-side>
                    <span class="icon-vender" :data-vendor="getVendor(rule)" data-size="s">{{rule.autoExeYn=='Y'?$te('PRODUCT.'+getProductListOfRule(rule)[0])?$t('PRODUCT.'+getProductListOfRule(rule)[0]):"":$t('LABEL.MANUAL_RULE')}}</span>
                    <template v-if="getProductListOfRule(rule).length > 1">
                        <button type="button" class="txt-status" data-status="key" :data-tooltip-content="'#tooltip-products-'+rule.ruleId" data-trigger="tooltip-tbl" >
                            {{$t('POLICY.RULE.OTHER_COUNT', {prodCnt: getProductListOfRule(rule).length - 1})}}
                        </button>
                        <div class="tooltip_templates">
                            <div :id="'tooltip-products-'+rule.ruleId">
                                <ul class="list-default">
                                    <li v-for="(prod, index) of getProductListOfRule(rule)" :key="index"><span class="icon-vender" data-vendor="aws" data-size="s">{{$t('PRODUCT.'+ prod)}}</span></li>
                                </ul>
                            </div>
                        </div>
                    </template>
                </td>
                <td v-on:click="openRuleDetail(rule, $event)" data-hide-by-side>
                    <span class="icon-serious" :data-status="rule.svrty === 4 ? 'critical' : rule.svrty === 3 ? 'high': rule.svrty === 2 ? 'medium': 'low'">{{getSeverityLabel(rule)}}</span>
                </td>
                <!-- 수정 / 복사 / 삭제 버튼 -->
                <td v-on:click="openRuleDetail(rule, $event)" v-if="isEditable && getMenuAuth === constants.AUTH_TYPE.EDIT" class="txt-c" data-hide-by-side>
                    <button type="button" class="buttons-icon" data-type="line"
                            data-size="s"
                            data-icon="edit"
                            :title="$t('COMMON.BUTTON.CAMEL.EDIT')"
                            data-trigger="popup-extension"
                            @click="callOpenPopup(rule, constants.FORM_TYPE.EDIT)">{{$t('COMMON.BUTTON.CAMEL.EDIT')}}</button>
                    <button type="button" class="buttons-icon" data-type="line"
                            data-size="s" data-icon="copy"
                            :title="$t('COMMON.BUTTON.CAMEL.COPY')"
                            data-trigger="popup-extension"
                            @click="callOpenPopup(rule, constants.FORM_TYPE.COPY)">{{$t('COMMON.BUTTON.CAMEL.COPY')}}</button>
                    <button type="button" class="buttons-icon" data-type="line"
                            data-size="s"
                            data-icon="delete"
                            :title="$t('COMMON.BUTTON.CAMEL.DELETE')"
                            data-trigger="delete-extension"
                            v-on:click="callDeleteRule([rule])">{{$t('COMMON.BUTTON.CAMEL.DELETE')}}</button>
                </td>
            </tr>
            <tr v-if="ruleList.length === 0">
                <td colspan="5" class="data row">
                    <div class="none">
                        {{ $t('POLICY.RULE.NO_APPLIED_RULE')}}
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    import _ from "lodash";

    export default {
        name: "SystemRuleList",
        props: {
            policy: Object,                // Rule들이 속해있는 Policy 정보
            curRule: Object,               // Detail 정보에서 열려있는 Rule 정보
            categoryList: Array,           // 회사에 등록되어있는 Category Label 정보 리스트
            isReplica: Boolean,            // 사용자설정 Policy 확인 플래그
            callOpenPopup: Function,
            ruleList: Array,
            callDeleteRule: Function,
            callOpenRuleDetail: Function,
            callHideRuleDetail:Function,
            callSetSearchKey: Function,
            callSetSortColumn: Function,
        },
        data: function() {
            return {
                checkList: [],
                searchCtg: [],                                 // Search category
                searchProd: [],                                // Search product
                searchSvrty: this.constants.PARAM.SELECT.SEARCH_SEVERITY,                     // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
                sortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order
                titlRender: 0
            }
        },
        computed: {
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            },
            templateList: function() {
                return this.$store.state.templateList
            },
            isEditable: function() {
                return true;
            },
            getCtgLabelFilterData: function () {
                let self = this
                let ctgFilter = [];
                if(typeof(_.head(this.ruleList)) !== this.constants.TYPE.UNDEFINED &&
                    typeof(_.head(this.templateList)) !== this.constants.TYPE.UNDEFINED) {
                    this.ruleList.forEach(function (r) {
                        for (let ctg of r.ctgLabel) {
                            let category = _.find(self.categoryList, {ctgId: ctg})
                            if(typeof(category) !== "undefined") {
                                ctgFilter.push({
                                    key: ctg,
                                    val: category.constructor === Object ? category.ctgLabel : ctg
                                })
                            }
                        }
                    })
                }
                return _.unionBy(ctgFilter, 'key');
            },
            getProdFilterData: function () {
                let self = this
                let prodFilter = [];
                if(typeof(_.head(this.ruleList)) !== this.constants.TYPE.UNDEFINED &&
                    typeof(_.head(this.templateList)) !== this.constants.TYPE.UNDEFINED) {
                    this.ruleList.forEach(function (r) {
                        for(let cnd of r.cndVal) {
                            let ruleProd = _.find(self.templateList, {'tmpltId': cnd.tmpltId});
                            let prod = _.get(ruleProd,'prod','manual');
                            prodFilter.push({'key': prod, val: self.$t('PRODUCT.'+prod), dataIcon:'aws'})
                        }
                    })
                }
                return _.unionBy(prodFilter, 'key');
            },
            selectCheckAll : {
                get: function() {
                    return this.ruleList ? this.checkList.length === this.ruleList.length : false;
                },
                set: function(value) {
                    let selected = [];
                    if (value) {
                        this.ruleList.forEach(function (rule) {
                            selected.push(rule);
                        })
                    }
                    this.checkList = selected;
                }
            }
        },
        watch: {
            'doRefresh': function () {
                this.initProductToolTip();
            },
            templateList: function(){
                this.$nextTick(function(){
                    this.initProductToolTip()
                })

            }
        },
        mounted() {
            document.getElementsByClassName("selection dropdown multiple")[0].addEventListener("click", this.clickOnSlctCtg);
            document.getElementsByClassName("selection dropdown multiple")[1].addEventListener("click", this.clickOnSlctProd);
        },
        created: function() {
            this.initMultiFilter();
            this.initProductToolTip();
        },
        methods:{
            clickOnSlctProd(e) {
                this.hideMenu("select_ctg");
                const firstChildNode = _.get(e, "target.firstChild.nodeName");
                if (firstChildNode !== "SELECT") return;
                const select = document.getElementsByClassName("select_prod multiple")[0];
                const target = select.getElementsByClassName("menu transition")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");
                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            },
            clickOnSlctCtg(e) {
                this.hideMenu("select_prod");
                const firstChildNode = _.get(e, "target.firstChild.nodeName");
                if (firstChildNode !== "SELECT") return;
                const select = document.getElementsByClassName("select_ctg multiple")[0];
                const target = select.getElementsByClassName("menu transition")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");

                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            },
            hideMenu(targetMenu) {
                const select = document.getElementsByClassName(`${targetMenu} multiple`)[0];
                const target = select.getElementsByClassName("menu transition")[0];
                if (target) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");
                    select.classList.remove("active");
                }
            },
            // 기존에 등록된 Policy 목록 조회(Policy 목록에 Rule, Condition 도 함께 조회)
            // Folder Open
            openRuleDetail: function (rule, $event) {
                if($event.target.nodeName !== 'BUTTON' && !this.isReplica) {
                    this.callOpenRuleDetail(rule);
                }
            },
            getCategoryLabel(ctgId) {
                var categoryLabel = ''
                for(var category of this.categoryList) {
                    if(category.ctgId === ctgId) {
                        categoryLabel = category.ctgLabel
                    }
                }
                return categoryLabel
            },
            // Replica
            removeRule(ruleList) {
                // TODO :: Rule List 에서 rule 삭제
                let self = this;
                _.forEach(ruleList, function (rule) {
                    self.ruleList.splice(_.findIndex(self.ruleList, rule), 1)
                })
            },
            getVendor(rule) {
                let vendors = [];
                if (this.templateList && this.templateList.length > 0) {
                    for (let condition of rule.cndVal) {
                        const conditionProd = _.find(this.templateList, {'tmpltId': condition.tmpltId});
                        let vendor = _.get(conditionProd, 'vendor');
                        vendor = this.Common.getVendorByKey(vendor);
                        vendors.push(vendor)
                    }
                    vendors = _.uniq(vendors)
                }
                return vendors;
            },
            getProductListOfRule(rule) {
                let prodArray = [];
                if(this.templateList && this.templateList.length > 0) {
                    for(let condition of rule.cndVal) {
                        let conditionProd = _.find(this.templateList, {'tmpltId' : condition.tmpltId});
                        let prod = _.get(conditionProd, 'prod', 'manual');
                        prodArray.push(prod)
                    }
                    prodArray = _.uniq(prodArray)
                }
                return prodArray
            },
            getSeverityLabel(rule) {
                return this.$t("LABEL.SVRTY." + rule.svrty)
            },
            initProductToolTip: function() {
                // 카테고리 라벨 & 프로덕트 목록 오버 툴팁
                $('[data-trigger="tooltip-tbl"]').tooltipster({
                    delay: 300,
                    animation: 'fade',
                    updateAnimation: 'fade',
                    side: 'bottom',
                    theme: 'go-sizetofit',
                    arrow: true,
                    contentAsHTML: true,
                })
            },
            initMultiFilter: function() {
                let $filterTarget = $('.buttons-tbl-header[data-type=filter]')
                $filterTarget.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-filter',
                    interactive: true,
                    trigger: 'click',
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });
            },
        },
    }
</script>
<style scoped>
    .data.row {
        display: table-cell;
    }
</style>



// WEBPACK FOOTER //
// src/components/bestpractice/systemRuleList.vue